import { RacemapAPIClient } from '@racemap/utilities/api-client';
import type { StoreApi } from 'zustand';
import type { State } from '../../reducers';
import { prepareFrontendBillableItems } from '../events_reducer_helper';
import type { EventsActions } from '../events_reducers';
import { type GetState, logAndToast, patchCurrentEvent, withSavingState } from './helpers';

const apiClient = RacemapAPIClient.fromWindowLocation();

async function reloadIfCurrent(get: GetState, eventId: string) {
  if (get().events.currentEventId === eventId) {
    await get().events.actions.loadCurrentEvent(eventId);
  }
}

export const createBillingActions = (
  set: StoreApi<State>['setState'],
  get: StoreApi<State>['getState'],
): Pick<
  EventsActions,
  'createEventSpecificUserCredit' | 'removeBillableItem' | 'removeEventSpecificUserCredit'
> => ({
  createEventSpecificUserCredit: (eventId, item) =>
    withSavingState(
      set,
      async () => {
        await apiClient.createUserCredit(item);
        await reloadIfCurrent(get, eventId.toString());
      },
      logAndToast('Failed to add user credit', 'Failed to add user credit.'),
    ),

  removeBillableItem: (eventId, itemId) =>
    withSavingState(
      set,
      async () => {
        await apiClient.removeBillableItem(itemId);
        if (get().events.currentEventId !== eventId) return;

        const billableItems = await apiClient.getEventBillableItems(eventId);
        patchCurrentEvent(set, get, eventId, (event) => ({
          billableItems: prepareFrontendBillableItems(billableItems, event),
        }));
      },
      logAndToast('Failed to remove the billable item', 'Failed to remove the billable item.'),
    ),

  removeEventSpecificUserCredit: (eventId, creditId) =>
    withSavingState(
      set,
      async () => {
        await apiClient.removeUserCredit({ userCreditId: creditId });
        await reloadIfCurrent(get, eventId.toString());
      },
      logAndToast('Failed to remove the user credit', 'Failed to remove the user credit.'),
    ),
});
